// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cookie a{text-underline-offset:3px;text-decoration:underline}@media (min-width:768px){#cookie a:hover{--text-opacity:1;color:#2d2a6c;color:rgba(45,42,108,var(--text-opacity))}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
